<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title
        :text="tipo_atividade ? tipo_atividade.nome : 'Carregando Planilha...'"
      />
      <div class="flex justify-end">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="border-radius: 25px"
              color="#031127"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Opções upload
            </v-btn>
          </template>
          <div class="flex flex-col mt-2 p-1">
            <v-btn
              color="#031127"
              dark
              @click.native="upload('arquivos-atividade.upload')"
            >
              Upload
            </v-btn>
            <v-btn
              class="mt-2"
              color="#031127"
              dark
              @click.native="upload('arquivos-atividade.nao-processadas')"
            >
              Upload não processados
            </v-btn>
                <v-btn
          v-if="hasRole('super-admin')"
          color="#031127"
          dark
          @click.native="AtualizarDadosPlanilha()"
          class="mt-2"
          >Carregar dados
        </v-btn>

          </div>
        </v-menu>
      </div>

      <div class="flex justify-end">
        <v-btn
          color="#031127"
          dark
          style="border-radius: 25px"
          @click.native="exportPlanilha('exportArquivoAtividade')"
        >
          Export {{tipo_atividade ? tipo_atividade.nome : 'Carregando Planilha...'}}
        </v-btn>
      </div>

      <div class="flex justify-end">
        <v-btn
          v-if="!competencia.gerado"
          color="#031127"
          style="border-radius: 25px"
          dark
          @click.native="carregarPlanilha()"
          class="mr-1"
          >Carregar panilha 
        </v-btn>
   <v-btn
          color="#031127"
          style="border-radius: 25px"
          dark
          @click.native="listar_dctfweb()"
          >Atualizar planilha
        </v-btn>

     
      </div>
    </div>

    <div class="w-full flex justify-start gap-4 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="Carteiras" class=" " />

        <treeselect
          :multiple="true"
          :options="lista_carteiras"
          placeholder="Selecione a(s) cidades(s)"
          v-model="filtros.carteira_filter"
        />
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Regime triburario" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.regime_tributario"
        >
          <!-- <option selected disabled>Selecione as carteiras...</option> -->

          <option :value="null">Todos</option>
          <option
            v-for="item in lista_regime_tributario"
            :key="item.id"
            :value="item.label"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Opções" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.opcoes"
        >
          <option :value="null">Todos</option>
          <option v-for="item in lista_opcoes" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Conferido" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.conferido"
        >
          <option
            v-for="item in [
              { id: null, label: 'Todos' },
              { id: 1, label: 'Concluido' },
              { id: 0, label: 'Desmarcado' },
              { id: 2, label: 'Não Concluido' },
            ]"
            :key="item.id"
            :value="item.id"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
    </div>
    <div class="w-full flex justify-start gap-2 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="ID Empresas" class=" " />

        <Lynx-Input v-model="empresas_id" />
      </label>
      <!-- <label class="w-1/4">
        <Lynx-Label label="Cidades" class=" " />

        <v-autocomplete
          v-model="filtros.cidades"
          :items="lista_cidades"
          :search-input.sync="searchQuery"
          item-text="nome"
          item-value="nome"
          label="Selecione a(s) cidades(s)"
          multiple
          dense
          @change="clearSearchQuery"
        />
      </label> -->
        <label class="w-1/5">
        <Lynx-Label label="Status" class=" " />

        <treeselect
          :multiple="true"
          :options="[{id:'pendente',label:'Pendente'},{id:'finalizado',label:'Finalizado'}]"
          placeholder="Selecione os status"
          v-model="filtros.status"
        />
      </label>

      <label class="">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>

      <!-- <label class="w-1/6">
      <Lynx-Label label="Faturamento" class=" " />
      <Lynx-Input v-model="faturamento"/>
    </label> -->
    </div>
    <div class="table-container" v-if="pagination">
      <b-table
        :loading="loading"
        backend-pagination
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        :columns="colunas"
        :data="loading ? [] : lista_dctfweb"
        paginated
        striped
        style="font-size: 12px"
        :style="tamanhoTela"
        :height="filtros.perPage == 10 ? '680' : '100%'"
      >
        <template slot-scope="props" v-if="props.row['id'] != null">
          <b-table-column
            :style="getColStyle(column.field)"
            v-for="column in colunas"
            :key="column.field"
            :field="column.field"
            v-show="column.field !== 'acoes'"
            style="height: 20px"
          >
            <template
              v-if="
                [
                  'empresa_id',
                  'cnpj',
                  'razao_social',
                  'carteiras',
                  'cidade',
                  'regime_tributario',
                ].includes(column.field)
              "
            >
              {{ props.row[column.field] }}
            </template>

              <template
              v-if="
                [
                  'inicio_atividades',
               
                ].includes(column.field)
              "
            >
              {{ props.row[column.field] | formatEnToBr}}
            </template>

            <b-select
              v-if="column.field === 'opcoes'"
              style="font-size: 13px"
              placeholder="Selecione as opções"
              name="form-class"
              v-model="props.row['opcoes']"
            >
              <option
              v-show="item.id != 5 || item.id == 5 && props.row.arquivo_dctfweb.length == 0"
                v-for="item in lista_opcoes"
                :key="item.id"
                :value="item.id"
              >
                {{ item.label }}
              </option>
            </b-select>

            <b-switch
              v-if="column.field === 'conferido'"
              v-model="props.row[column.field]"
              :true-value="1"
              :false-value="0"
            />

            <div
              v-if="column.field === 'status'"
              :class="`p-1 text-neutral-900 text-uppercase ${
                props.row.status === 'pendente'
                  ? 'bg-warning-base'
                  : 'bg-success-base'
              }`"
            >
              {{ props.row.status }}
            </div>

            <div
              v-if="
                column.field === 'arquivoDctfweb' &&
                props.row.arquivo_dctfweb != null
              "
            >
              <span
                class="py-1 px-2 bg-neutral-300 rounded mr-2 mb-2 text-xs"
                v-show="!arquivo.user_del"
                v-for="(arquivo, key) in props.row.arquivo_dctfweb"
                :key="key"
                v-text="arquivo.tipo"
              >
              </span>
            </div>
          </b-table-column>

          <b-table-column
            style="
              width: 200px;
              position: absolute;
              right: 35px;
              z-index: 100;
              background-color: #031127;
              color: white;
            "
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="#051b3e" dark v-on="on">
                  Ações
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="atualizarPlaniha(props, props.row)">
                  <v-list-item-title>Salvar</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openArquivosAtividadeModal(props.row)">
                  <v-list-item-title
                    >Arquivo
                    <v-icon class="ml-1">mdi-eye</v-icon></v-list-item-title
                  >
                </v-list-item>
                <v-list-item
                  v-if="hasRole('super-admin') && props.row.user_up"
                  @click="open(props.row.user_up)"
                >
                  <v-list-item-title
                    >Logs
                    <v-icon class="ml-1">mdi-eye</v-icon>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-snackbar
              v-if="logs"
              color="primary"
              shaped
              v-model="logs"
              :vertical="false"
            >
              <span style="font-size: 15px"
                >ATUALIZOU: {{ user_up.toUpperCase() }}
              </span>
              <br />
              <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

              <template v-slot:action="{ attrs }">
                <v-btn color="error" icon v-bind="attrs" @click.native="hide()">
                  <v-icon large> mdi-close </v-icon>
                </v-btn>
              </template>
            </v-snackbar>
          </b-table-column>
        </template>
        <template #empty>
          <div class="w-full flex justify-center">
            <Not-Found-Data text="Nenhum Tabela carregada!" />
          </div>
        </template>
      </b-table>
      <div class="float-left" style="margin-top: -60px">
        <b-pagination
          :total="pagination.total"
          :current.sync="current_page"
          :per-page="pagination.per_page"
        />
      </div>
    </div>
    <b-modal :active.sync="arquivosAtividadeModal" >
      <GerenciamentoArquivoAtividadeDetails
        :current-arquivo-atividade="currentArquivosAtividade"
        @atualizar="listar_dctfweb()"
      />
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";
import InputMoney from "@/components/helpers/InputMoney";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import { usersRequest } from "@/services/requests/users";
import GerenciamentoArquivoAtividadeDetails from "@/views/atividadesCompetencia/arquivosAtividade/GerenciamentoArquivoAtividadeDetails";
import Treeselect from "@riophae/vue-treeselect";

import { showCidadesRequest } from "../../services/requests/estados";

export default {
  components: {
    NotFoundData,
    InputMoney,
    Treeselect,
    GerenciamentoArquivoAtividadeDetails,
  },
  data() {
    return {
      monthNames,
      form: [],
      selectedFiles: [],
      loading: false,
      loadingInicial: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      logs: false,
      currentArquivosAtividade: {},
      arquivosAtividadeModal: false,
      searchQuery: null,
      columns: [
        // {
        //   field: "id",
        //   label: "id",
        //   sortable: true,
        // },
        {
          field: "empresa_id",
          label: "empresa_id",
          sortable: true,
        },

        {
          field: "cnpj",
          label: "cnpj",
        },
        {
          field: "razao_social",
          label: "razão social",
          sortable: true,
        },
        {
          field: "carteiras",
          label: "carteiras",
          sortable: true,
        },
        {
          field: "regime_tributario",
          label: "regime tributario",
        },
        {
          field: "opcoes",
          label: "opcoes",
          sortable: true,
        },
        {
          field: "arquivoDctfweb",
          label: "arquivo",
          sortable: true,
        },
        {
          field: "conferido",
          label: "DP",
          sortable: true,
        },
        {
          field: "status",
          label: "status",
          sortable: true,
        },
        {
          field: "acoes",
          label: "acoes",
        },
      ],

      lista_opcoes: [
        { id: 1, label: "Ok" },
        { id: 2, label: "Sem movimento" },
        { id: 3, label: "Sem procuração" },
        { id: 4, label: "Optante pelo simples nacional"},
        { id: 5, label: "Sem arquivo"}

      ],

      lista_usuarios: null,
      user_up: false,
      faturamento: 0,
      lista_regime_tributario: [
        { id: "Simples Nacional", label: "Simples Nacional" },
        { id: "Lucro Presumido", label: "Lucro Presumido" },
        { id: "Isento", label: "Isento" },
        {
          id: "Aguardando enquadramento no simples",
          label: "Aguardando enquadramento no simples",
        },
        { id: "presumido com equiparação", label: "presumido com equiparação" },
        {
          id: "Microempreendedor Individual (MEI)",
          label: "Microempreendedor Individual (MEI)",
        },
      ],

      dctfweb_fechamento: null,
      empresas_id: "",
      lista_cidades: null,
      filtros: {
        page: 1,
        empresas_id: null,
        status: null,
        carteira_filter: [],
        conferido: null,
        regime_tributario: null,
        opcoes: null,
        perPage: 10,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  watch: {
    "filtros.perPage"() {
      this.listar_dctfweb();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_dctfweb();
    },
    faturamento() {
      if (this.faturamento < 1) {
        this.faturamento = 0;
      }
    },
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400), // Adiciona um atraso de 300ms para evitar múltiplas chamadas durante a digitação
  },

  computed: {
    ...mapGetters(["getToken"]),
    tamanhoTela() {
      const tamanhoFixo = this.calcularTamanhoTabela();
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      // data.push({ id: 'todas', label: 'todas',disabled:true });

      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      return data;
    },

    dctfweb() {
      return this.$store.state.dctfweb.lista_dctfweb;
    },
    lista_dctfweb() {
      return this.dctfweb.data;
    },
    pagination() {
      return this.dctfweb.pagination;
    },
    tipo_atividade() {
      return this.dctfweb.tipo_atividade;
    },
    colunas() {
      let customColumns = this.dctfweb.colunas
        .filter((field) => field !== "user_up")
        .map((field) => ({
          field,
          label: field.replace("_", " "),
          sortable: true,
        }));

      customColumns.push({
        field: "arquivoDctfweb",
        label: "arquivo",
        sortable: true,
      });
      customColumns.push({
        field: "acoes",
        label: "ações",
        sortable: true,
      });

      return customColumns;
    },
    competencia() {
      return {
        gerado: this.dctfweb.gerado,
        competencia: this.dctfweb.competencia,
      };
    },

    mensagem_alert() {
      return this.$store.state.dctfweb.mensagem_alert;
    },
  },
  created() {
    this.getUsers();
    this.fetchCarteiras();
  },
  mounted() {
    this.listar_dctfweb_inicial();
  },
  filters: {
    formatEnToBr,
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    hasRole,
    async fetchCarteiras() {
      await this.$store.dispatch("carteira/listar_carteiras");
    },
    pegarUsuario(val) {
      let a = this.lista_usuarios.filter((item) => item.id == val);

      this.user_up = a[0].label;
    },
    clearSearchQuery() {
      this.searchQuery = "";
    },
    searchCidades() {
      this.loading = true;

      showCidadesRequest(this.searchQuery)
        .then((res) => (this.lista_cidades = res.data))
        .finally(() => (this.loading = false));
    },
    async getUsers() {
      await usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];
        for (let i = 0; i < data.length; i++) {
          arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
        }
        this.lista_usuarios = arrayNew;
      });
      // console.log(this.lista_usuarios);
    },
    open(val) {
      this.pegarUsuario(val);
      this.logs = true;
    },
    hide() {
      this.logs = false;
    },
    enterCompetencia() {
      this.$router.push({ name: "dctfweb.fechamento" });
    },
    async listar_dctfweb_inicial() {
      this.loadingInicial = true;
      await this.listar_dctfweb();
      this.loadingInicial = false;
    },
    async listar_dctfweb() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;

      let rota = "dctfweb/" + this.$route.params.atividade_competencia_id;

      await this.$store.dispatch("dctfweb/listar_dctfweb", {
        rota: rota,
        filtros: filtros,
      });
      this.loading = false;
    },

   async AtualizarDadosPlanilha() {
      this.loading = true;
      await this.$store.dispatch("dctfweb/atualizar_dados_planilha", {
        atividade_competencia_id: this.$route.params.atividade_competencia_id,
      });
      this.loading = false;
      this.listar_dctfweb();
    },
    async carregarPlanilha() {
      this.loading = true;
      await this.$store.dispatch("dctfweb/carregar_dctfweb", {
        atividade_competencia_id: this.$route.params.atividade_competencia_id,
      });
      this.loading = false;
      this.listar_dctfweb();
    },
    getCamposAlterados(novoValor, valorAntigo) {
      let camposAlterados = {};

      // console.log(valorAntigo)
      const valores = ["opcoes", "status", "conferido", "user_up"];
      camposAlterados["id"] = novoValor["id"];

      for (let i = 0; i < valores.length; i++) {
        console.log(
          valores[i] +
            ": " +
            novoValor[valores[i]] +
            "!==" +
            valorAntigo[valores[i]]
        );
        if (novoValor[valores[i]] !== valorAntigo[valores[i]]) {
          camposAlterados[valores[i]] = novoValor[valores[i]];
        }
      }

      return camposAlterados;
    },
    async atualizarPlaniha(props, value) {
      await this.$store
        .dispatch("dctfweb/update_dctfweb", value)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPageChange(page) {
      this.current_page = page;
    },
    async exportPlanilha(nome) {
      this.loading = true;
      let data = {
        id: this.$route.params.atividade_competencia_id,
        tipo: "dctfweb",
      };
      await this.$store.dispatch("empresas/" + nome, data);
      this.loading = false;
    },
    handleClick(value) {
      // Ação ao clicar (clique duplo)
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${value}/open?token=${this.getToken}`
      );
    },
    upload(route) {
      this.$router.push({
        name: route,
        params: {
          atividade_competencia_id: this.$route.params.atividade_competencia_id,
        },
      });
    },
    getColStyle(field) {
      switch (field) {
        case "empresa_id":
          return "width: 80px;  position: sticky;left: 0; background-color: #fff;z-index: 1;background-color:#031127; color:white";
          break;
        case "cnpj":
          return "width: 100px;  position: sticky;left: 80px; background-color: #fff;z-index: 2;background-color:#031127; color:white";
          break;
        case "razao_social":
          return "width: 400px;";
          break;
        case "regime_tributario":
          return "width: 300px;";
          break;
        case "opcoes":
          return "width: 250px;";
          break;
        case "conferido":
          return "width: 200px;";
          break;

        default:
          return "width: 200px;";
          break;
      }
    },
    calcularTamanhoTabela() {
      let totalWidth = 0;
      this.colunas.map((column) => {
        switch (column.field) {
          case "empresa_id":
            totalWidth += 80;
            break;
          case "cnpj":
            totalWidth += 100;
            break;
          case "razao_social":
            totalWidth += 400;
            break;
          case "regime_tributario":
               totalWidth += 300;
            break;
          case "opcoes":
            totalWidth += 250;
            break;
          default:
            totalWidth += 200;
            break;
        }
      });
      totalWidth += 100;

      return totalWidth;
    },

    openArquivosAtividadeModal(arquivosAtividade) {
      this.currentArquivosAtividade = arquivosAtividade;
      this.arquivosAtividadeModal = true;
    },
    closeArquivosAtividadeModal() {
      this.arquivosAtividadeModal = false;
      this.currentArquivosAtividade = {};
    },
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  width: 100%;
}
</style>

  